// extracted by mini-css-extract-plugin
export default {"header_logo_container":"index_header_logo_container__WBbl0","header_logo_container_mini":"index_header_logo_container_mini__1Lc-8","header_logo":"index_header_logo__VEYu3"};